import React from 'react';
import { StarFilledIcon } from '@domain-group/fe-co-icon';
import RmaLogo from '../shared/recommendations/rma-logo';
import { COMPONENT_IDS } from '../../constants';
import * as styles from './agent-profile-overview.style';

export type ReviewRatingProps = {
  overallStarRating: number;
  totalReviews: number;
  onRatingClick?: () => void;
};

const ReviewRating = ({
  overallStarRating,
  totalReviews,
  onRatingClick,
}: ReviewRatingProps): JSX.Element => {
  const label = `${overallStarRating.toFixed(1)} (${totalReviews} ${
    totalReviews === 1 ? 'review' : 'reviews'
  })`;

  const handleRatingClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const targetElement = document.querySelector(
      `#${COMPONENT_IDS.recommendations}`,
    );

    if (targetElement) {
      const headerOffset = 50;
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    onRatingClick?.();
  };

  return (
    <button
      type="button"
      css={styles.ratingRow}
      onClick={handleRatingClick}
      aria-label={label}
    >
      <StarFilledIcon
        css={styles.ratingStar}
        data-testid="rating-star"
        size="regular"
      />
      <span css={styles.ratingText}>{label}</span>
      <span css={styles.ratingSeparator}>|</span>
      <RmaLogo height={22} marginLeft={0} marginTop={6} />
    </button>
  );
};

export default ReviewRating;
